import { EndSessionResponse } from '@/domain/types';

interface SessionEndModalProps {
  result: EndSessionResponse;
  onClose: () => void;
}

export function SessionEndModal({ result, onClose }: SessionEndModalProps) {
  const totalTaps = result.level1Taps + result.level2Taps + result.level3Taps;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-sm animate-in fade-in zoom-in rounded-2xl bg-surface-card p-6 shadow-2xl">
        {/* Header */}
        <div className="mb-4 text-center">
          <div className="mb-2 text-5xl">🎉</div>
          <h2 className="text-xl font-bold text-white">Session Complete!</h2>
        </div>

        {/* Points earned */}
        <div className="mb-6 rounded-xl bg-gradient-to-r from-accent-gold/20 to-accent-orange/20 p-4 text-center">
          <p className="text-sm text-gray-400">Points Earned</p>
          <p className="text-4xl font-bold text-accent-gold">+{result.pointsAwarded}</p>
        </div>

        {/* Stats breakdown */}
        <div className="mb-6 space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-400">Total Taps</span>
            <span className="font-medium text-white">{totalTaps}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Level 1 Taps</span>
            <span className="text-gray-300">{result.level1Taps} × 1 pt</span>
          </div>
          <div className="flex justify-between">
            <span className="text-cyan-400">Level 2 Taps</span>
            <span className="text-cyan-300">{result.level2Taps} × 2 pts</span>
          </div>
          <div className="flex justify-between">
            <span className="text-orange-400">Level 3 Taps</span>
            <span className="text-orange-300">{result.level3Taps} × 3 pts</span>
          </div>
        </div>

        {/* New total */}
        <div className="mb-6 text-center">
          <p className="text-xs text-gray-500">New Total Points</p>
          <p className="text-2xl font-bold text-white">{result.totalPoints.toLocaleString()}</p>
        </div>

        {/* Close button */}
        <button
          onClick={onClose}
          className="w-full rounded-xl bg-primary-500 py-3 font-semibold text-white transition-colors hover:bg-primary-600 active:scale-98"
        >
          Continue
        </button>
      </div>
    </div>
  );
}
